import APIService from '@/services/api';
import {IInterface, ITag} from '@/shared/services/models/Interface';
import {IStatus} from '@/shared/services/models/Status';
import {IRecording} from '@/shared/services/models/Recording';
import {ILicences} from '@/shared/services/models/Licences';
import {IAllowBlockList} from '@/shared/services/models/AllowBlockList';
import {IService} from '@/shared/services/models/Service';
import {ISetting} from '@/shared/services/models/Setting';
import {IBoroSettings} from '@/shared/services/models/BoroSettings';
import {IVersions} from '@/shared/services/models/Versions';
import {ICommandResponse, IServer} from '@/shared/services/models/Server';
import {IStatisticsSummary} from '@/shared/services/models/StatisticsSummaries';
import {INetwork} from '@/shared/services/models/Network';
import {ICinegyRouteSource} from '@/shared/services/models/CinegyRouteSource';
import {IEvent} from '@/shared/services/models/Event';
import {IGeoIP} from '@/shared/services/models/GeoIP';
import {IPlaylist} from '@/shared/services/models/Playlist';

import { faLeaf } from '@fortawesome/free-solid-svg-icons';

import Vue from 'vue';

import Vuex from 'vuex';

import modules from './modules';
import { IAccessControl } from '@/shared/services/models/AccessControl';
import API from '@aws-amplify/api';


Vue.use(Vuex);

export interface StoreState {
    interfaces: IInterface[];
    statuses: IStatus[];
    recordings: IRecording[];
    licences: ILicences;
    prices: { [key: string]: string };
    allowBlockLists: IAllowBlockList[];
    services: IService[];
    settings: ISetting[];
    accessControl: IAccessControl[];
    boroSettings: IBoroSettings;
    versions: IVersions;
    serverStatus: IServer;
    statisticsSummary: IStatisticsSummary;
    networkConfig: INetwork;
    cinegyRouteSources: ICinegyRouteSource[];
    cinegyRouteDestinations: string[];
    tags: ITag[];
    events: IEvent[];
    eventCount: number;
    newEvents: IEvent[];
    locations: { [key: string]: IGeoIP };
    eventUpdateInprogress: boolean;
    playlists: IPlaylist[];
    cognitoInfo: any;
    loggedIn: boolean;
    loadingState: boolean;
    errorLoadingState: boolean;
    capturePath: string;
    statisticsKeepDuration: number;
    statisticsSummaryUpdated: Date;
    toastMode: string;
    commandStatus: ICommandResponse|null;
    commandStatusMTR: ICommandResponse|null;
    commandLastId: string|null;
    commandLastIdMTR: string|null;
}

export default new Vuex.Store({
    state: {
        interfaces: [],
        statuses: [],
        username: '',
        groups: [],
        recordings: [],
        prices: { },
        allowBlockLists: [],
        services: [],
        settings: [],
        accessControl: [],
        boroSettings: {
            name: '',
            id: '',
            description: '',
            url: '',
            proxy: '',
            key: '',
        },
        licences: {
                srt: false,
                rist: false,
                rtmp: false,
                hls: false,
                cinegy_route: false,
                capture_playback: false,
                relay: false,
                tudp: false,
                zixi: false,
                ndi: false,
                biss: false,
                interfaces: 0,
                multi_output: false,
                trial: false,
                trial_end_date: undefined,
        },
        networkConfig: {
            network: {
                ethernets : {},
                version: 0,
                vlans : {},
            },
        },
        cinegyRouteDestinations: [],
        cinegyRouteSources: [],
        tags: [],
        events: [],
        eventCount: 0,
        newEvents: [],
        locations: {},
        versions: {
            application: '',
            udp: '',
            srt: '',
            rist: '',
            rtmp: '',
            cinegy_route: '',
            capture_playback: '',
            zixi_client: '',
            zixi_feeder: '',
        },
        serverStatus: {
            address: {},
            cpu: [],
            processes: [],
            uptime: 0,
            cpu_info: {
                cache: '',
                cores: '',
                frequency: '',
                model: '',
            },
            memory: {
                MemAvailable: '',
                MemFree: '',
                MemTotal: '',
                Buffers: '',
                Cached: '',
                SwapCached: '',
                SwapFree: '',
                SwapTotal: '',
            },
            sensors: {},
            gpu_processes: [],
            gpu_info: [],
            buffers: {
                mem_default: -1,
                mem_max: -1,
                netdev_max_backlog: -1,
                optmem_max: -1,
                wmem_default: -1,
                wmem_max: -1,
            },
            net_buffers: {},
             rp_filter: {},
            cpu_governor: {},
            server_info: {},
        },
        statisticsSummary: {
            long_interval: [],
            short_interval: [],
        },
        eventUpdateInprogress: false,
        playlists: [],

        cognitoInfo: {},
        loggedIn: false,
        loadingState: true,
        errorLoadingState: false,
        updating: false,
        capturePath: '/mnt/d/Captured',
        statisticsKeepDuration: 600,
        statisticsSummaryUpdated: new Date(),
        toastMode: 'all',
        commandStatus: null,
        commandLastId: null,
        commandLastIdMTR: null,
        commandStatusMTR: null,
    } as StoreState,
    mutations: {
        updateGeoIP(state, {ip, geoip}) {
            Vue.set(state.locations, ip, geoip);
        },
        mutatePrices(state): void {
            const data: { [key: string]: string } = {};
            const srtKey = 'srt';
            const ristKey = 'rist';
            const rtmpKey = 'rtmp';
            const hlsKey = 'hls';
            const cinegyRouteKey = 'cinegy_route';
            const capturePlaybackKey = 'capture_playback';
            const interfacesKey = 'interfaces';
            const multiOutputKey = 'multi_output';
            const tudpKey = 'tudp';
            const relayKey = 'relay';
            const zixiKey = 'zixi';
            const bissKey = 'biss';
            const trialKey = 'trial';
            const ndiKey = 'ndi';
            const trialEndDateKey = 'trial_end_date';

            data[srtKey] = '$50';
            data[ristKey] = '$50';
            data[rtmpKey] = '$50';
            data[hlsKey] = '$50';
            data[cinegyRouteKey] = '$50';
            data[capturePlaybackKey] = '$100';
            data[multiOutputKey] = '$100';
            data[tudpKey] = '$50';
            data[relayKey] = '$100';
            data[interfacesKey] = '$50 per interface';
            data[zixiKey] = '$50';
            data[bissKey] = '$100';
            data[ndiKey] = '$100';
            data[trialKey] = '$0';
            data[trialEndDateKey] = '$0';

            Vue.set(state, 'prices', data);
        },
        mutateRecordings(state): void {
            APIService.GetRecordings().then((data) => {
                // @ts-ignore
                Vue.set(state, 'recordings', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings recordings', err);
            });
        },
        mutatePlaylists(state): void {
            APIService.GetPlaylists().then((data) => {
                // @ts-ignore
                Vue.set(state, 'playlists', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings recordings', err);
            });
        },
        mutateInterfaces(state): void {
            APIService.GetInterfaces().then((data) => {
                if (state.interfaces && state.interfaces.length ===  data.length && data.length > 0) { // to ensure i don't loose the statistics for the interface
                    data.forEach((i) => {
                        let ii: number = 0;
                        state.interfaces.forEach((si) => {
                            if (i.id === si.id) {
                                // @ts-ignore
                                Vue.set(state.interfaces[ii], 'nr', i.nr);
                                // @ts-ignore
                                Vue.set(state.interfaces[ii], 'name', i.name);
                                // @ts-ignore
                                Vue.set(state.interfaces[ii], 'type', i.type);
                                // @ts-ignore
                                Vue.set(state.interfaces[ii], 'state', i.state);
                                // @ts-ignore
                                Vue.set(state.interfaces[ii], 'auto_start', i.auto_start);
                                // @ts-ignore
                                Vue.set(state.interfaces[ii], 'srt_connection_limit', i.srt_connection_limit);
                                // @ts-ignore
                                Vue.set(state.interfaces[ii], 'allow_block_list_id', i.allow_block_list_id);
                                // @ts-ignore
                                Vue.set(state.interfaces[ii], 'input', i.input);
                                // @ts-ignore
                                Vue.set(state.interfaces[ii], 'output', i.output);
                            }

                            ii++;
                        });
                    });
                } else {
                    // @ts-ignore
                    Vue.set(state, 'interfaces', data);
                }
        }).catch((err: any) => {
            // tslint:disable-next-line:no-console
            console.log('Error gettings interfaces', err);
        });
        },
        mutateLicences(state): void {
            APIService.GetLicenses().then((data) => {
                // @ts-ignore
                Vue.set(state, 'licences', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings licences', err);
            });
        },
        mutateAllowBlockLists(state): void {
            APIService.GetAllowBlockList().then((data) => {
                // @ts-ignore
                Vue.set(state, 'allowBlockLists', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings allowBlockLists', err);
            });
        },
        mutateAccessControl(state): void {
            APIService.GetAccessControl().then((data) => {
                // @ts-ignore
                Vue.set(state, 'accessControl', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings accessControl', err);
            });
        },
        mutateServices(state): void {
            APIService.GetServices().then((data) => {
                // @ts-ignore
                Vue.set(state, 'services', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings services', err);
            });
        },
        mutateSettings(state): void {
            APIService.GetSettings().then((data) => {
                if (data && Array.isArray(data) && data.length > 0) {
                    data.forEach((s: ISetting) => {
                        if (s.key === 'statistics.keep.duration') {
                            let keepDuration: number = 600;
                            try {
                                keepDuration = parseInt(s.value, 10);
                            } catch (E) {
                                window.console.error('Failed to parse keepDuration', E);
                            }

                            // @ts-ignore
                            Vue.set(state, 'statisticsKeepDuration', keepDuration);
                        } else if (s.key === 'ui.toast') {
                            // @ts-ignore
                            Vue.set(state, 'toastMode', s.value);
                        }
                    });
                }
                // @ts-ignore
                Vue.set(state, 'settings', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings settings', err);
            });
        },
        mutateBoroSettings(state): void {
            APIService.GetBoroSettings().then((data) => {
                // @ts-ignore
                Vue.set(state, 'boroSettings', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings boro settings', err);
            });
        },
        mutateVersions(state): void {
            APIService.GetVersions().then((data) => {
                // @ts-ignore
                Vue.set(state, 'versions', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings versions', err);
            });
        },
        mutateServerStatus(state): void {
            APIService.GetServerStatus().then((data) => {
                // @ts-ignore
                Vue.set(state, 'serverStatus', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings server status', err);
            });
        },
        mutateNetworkConfig(state): void {
            APIService.GetNetworkConfig().then((data) => {
                // @ts-ignore
                Vue.set(state, 'networkConfig', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings network config', err);
            });
        },
        mutateNetworkConfig2(state, networkConfig): void {
            // @ts-ignore
            Vue.set(state, 'networkConfig', networkConfig);
        },
        mutateStatisticsSummary(state): void {
            APIService.GetStatisticsSummary().then((data) => {
                // @ts-ignore
                Vue.set(state, 'statisticsSummary', data);
                Vue.set(state, 'statisticsSummaryUpdated', new Date());
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings statistics summary', err);
            });
        },
        mutateCinegyRouteSources(state): void {
            APIService.GetCinegyRouteSources().then((data) => {
                // @ts-ignore
                Vue.set(state, 'cinegyRouteSources', data);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings Cinegy Route sources', err);
            });
        },
        mutateCinegyRouteDestinations(state): void {
            APIService.GetCinegyRouteDestinations().then((data) => {
                // @ts-ignore
                Vue.set(state, 'cinegyRouteDestinations', data.sort());
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings events', err);
            });
        },
        mutateTags(state): void {
            APIService.GetTags().then((data) => {
                // @ts-ignore
                Vue.set(state, 'tags', data.sort( ( l: ITag, r: ITag ) => ( l.name < r.name ) ? -1 : 1 ));
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error gettings tags', err);
            });
        },
        mutateEvents(state): void {
            if (!state.eventUpdateInprogress) {
                state.eventUpdateInprogress = true;
                let timestamp: string|undefined;
                if (state.events && state.events.length > 0) {
                    timestamp = state.events[state.events.length - 1].timestamp;
                }

                APIService.GetEvents(timestamp).then((data) => {
                    if (timestamp) {
                        let events: IEvent[] = state.events.concat(data);

                        events = events.sort((l: IEvent, r: IEvent) => {
                            if (l.timestamp > r.timestamp) {
                                return -1;
                            } else if (l.timestamp < r.timestamp) {
                                return 1;
                            }
                            return 0;
                        });

                        // @ts-ignore
                        Vue.set(state, 'events', events);
                        const newEvents: IEvent[] = data.sort((l: IEvent, r: IEvent) => {
                            if (l.timestamp > r.timestamp) {
                                return -1;
                            } else if (l.timestamp < r.timestamp) {
                                return 1;
                            }

                            return 0;
                        });
                        // @ts-ignore
                        Vue.set(state, 'newEvents', newEvents);
                    } else {
                        const events: IEvent[] = data.sort((l: IEvent, r: IEvent) => {
                            if (l.timestamp > r.timestamp) {
                                return -1;
                            } else if (l.timestamp < r.timestamp) {
                                return 1;
                            }

                            return 0;
                        });
                        // @ts-ignore
                        Vue.set(state, 'events', events);
                    }
                    state.eventUpdateInprogress = false;
                }).catch((err: any) => {
                    // tslint:disable-next-line:no-console
                    console.log('Error gettings events', err);
                    state.eventUpdateInprogress = false;
                });

                APIService.GetEventCount().then((nr) => {
                    Vue.set(state, 'eventCount', nr);
                }).catch((err: any) => {
                    // tslint:disable-next-line:no-console
                    console.log('Error gettings event count', err);
                });
            }
        },
        mutateResetInterfaces(state): void {
            Vue.set(state, 'interfaces', []);
        },
        mutateCommandStatus(state, status): void {
            Vue.set(state, 'commandStatus', status);
        },
        mutateCommandStatusMTR(state, status): void {
            Vue.set(state, 'commandStatusMTR', status);
        },
        mutateCommandLastId(state, id): void {
            Vue.set(state, 'commandLastId', id);
        },
        mutateCommandLastIdMTR(state, id): void {
            Vue.set(state, 'commandLastIdMTR', id);
        },
        mutateStatus(state): void {
            let timestamp: string = '';
            if (state && state.interfaces && Array.isArray(state.interfaces)) {
                state.interfaces.forEach((i) => {
                    if (i.live && i.live.state === 1 && i.lastTimestamp) {
                        if (timestamp !== '' && new Date(i.lastTimestamp) < new Date(timestamp)) {
                            timestamp = i.lastTimestamp;
                        } else if (timestamp === '') {
                            timestamp = i.lastTimestamp;
                        }
                    }
                });
            }
            const now: number = (new Date()).getTime();
            const timestampTime = (new Date(timestamp + 'Z')).getTime();

            if ((now - timestampTime) / 1000 > 120) {
                timestamp = new Date(Date.now() - 120000).toUTCString();
            }
            Vue.set(state, 'updating', true);
            APIService.GetStatus(timestamp).then((data: IStatus[]) => {
                if (data && Array.isArray(data)) {
                    if (state && state.interfaces && Array.isArray(state.interfaces)) {
                        state.interfaces.forEach((i, index) => {
                            if (i.live) {
                                i.live.state = 0;
                            }
                            i.state = 0;
                        });
                    }

                    /*if (data.length == 0) { // all interfaces is of

                    }*/

                    data.sort((l: IStatus, r: IStatus): number => {
                        if (l && r) {
                            if (new Date(l.timestamp) > new Date(r.timestamp)) {
                                return 1;
                            } else if (new Date(r.timestamp) > new Date(l.timestamp)) {
                                return -1;
                            }
                        }
                        return 0;
                    }).forEach((status: IStatus) => {
                        if (state && state.interfaces && Array.isArray(state.interfaces)) {
                            state.interfaces.forEach((i, index) => {
                                if (i.id === status.id) {
                                    if (!i.live) {
                                        i.live = {
                                            id: status.id,
                                            nr: i.nr,
                                            name: status.name,
                                            type: status.type,
                                            state: status.state,
                                            auto_start: status.auto_start,
                                            input: status.input,
                                            output: status.output,
                                            statistics: [],
                                            started_at: status.started_at,
                                            packet_bunching: i.packet_bunching,
                                        };
                                    } else {
                                        i.live.nr = i.nr;
                                        i.live.name = status.name;
                                        i.live.type = status.type;
                                        i.live.state = status.state;
                                        i.live.auto_start = status.auto_start;
                                        i.live.input = status.input;
                                        i.live.output = status.output;
                                        i.live.started_at = status.started_at;
                                        i.live.packet_bunching = i.packet_bunching;
                                    }

                                    if ((i.lastTimestamp && new Date(status.timestamp) > new Date(i.lastTimestamp))) {
                                        i.live.statistics.push(status);
                                    } else if (i.lastTimestamp === undefined && status !== undefined && status !== null && status.timestamp !== undefined && status.timestamp !== null) {
                                        i.live.statistics.push(status);
                                    }

                                    while (i.live && i.live.statistics && i.live.statistics.length > (state.statisticsKeepDuration / 2)) { // 1s between each point and 2.5 min of data
                                        i.live.statistics.shift();
                                    }

                                    i.state = status.state;
                                    if (status.timestamp) {
                                        // this.lastTimestamp = status.timestamp;
                                        i.lastTimestamp = status.timestamp;
                                    }
                                }
                            });
                        }
                    });
                }

                Vue.set(state, 'statuses', data);
                Vue.set(state, 'updating', false);
            }).catch((err: any) => {
                // tslint:disable-next-line:no-console
                console.log('Error getting statistics', err);
                Vue.set(state, 'statuses', []);
                Vue.set(state, 'updating', false);
            });
        },
        setLoggedIn(state, newValue) {
            // state.loggedIn = newValue;
            Vue.set(state, 'loggedIn', newValue);
        },
        setLoggedOut(state) {
            // state.loggedIn = false;
            // state.cognitoInfo = {};
            Vue.set(state, 'loggedIn', false);
            Vue.set(state, 'cognitoInfo', {});
        },
        setCognitoInfo(state, newValue) {
            // state.cognitoInfo = newValue;
            Vue.set(state, 'cognitoInfo', newValue);
            // console.log('cognitoInfo', newValue);
        },
        setUsername(state, newValue) {
            if (newValue && newValue.toLowerCase() === 'christoffer@mediaatmos.com') {
                Vue.set(state, 'username', 'christoffer@branzell.se');
            } else if (newValue && newValue.toLowerCase() === 'andrew@mediaatmos.com') {
                Vue.set(state, 'username', 'anders@hoog.it');
            } else {
                Vue.set(state, 'username', newValue);
            }
        },
        setGroups(state, newValue) {
            Vue.set(state, 'groups', newValue);
        },
    },
    actions: {
        loadGeoIP(state, ip) {
            APIService.GetGeoIP(ip).then((geoip) => {
                this.commit('updateGeoIP', { ip, geoip });
            });
        },
        async startInterface(state, {id, nr}) {
            await APIService.StartInterface(id, nr);
        },
        async stopInterface(state, {id, nr}) {
            await APIService.StopInterface(id, nr);
        },
        async executeCommand(state, {command, address, nic}) {
            if (command === 'ping') {
                this.commit('mutateCommandStatus', null);
                this.commit('mutateCommandLastId', null);
                const c = await APIService.ExecuteCommand(command, address, nic);
                this.commit('mutateCommandLastId', c.uuid);
            } else {
                this.commit('mutateCommandStatusMTR', null);
                this.commit('mutateCommandLastIdMTR', null);
                const c = await APIService.ExecuteCommand(command, address, nic);
                this.commit('mutateCommandLastIdMTR', c.uuid);
            }
        },
        async checkCommandStatus(state, id) {
            const commandStatus = await APIService.CheckCommandStatus(id);
            this.commit('mutateCommandStatus', commandStatus);
        },
        async checkCommandStatusMTR(state, id) {
            const commandStatus = await APIService.CheckCommandStatus(id);
            this.commit('mutateCommandStatusMTR', commandStatus);
        },
        async forceStopInterface(state, {id, nr}) {
            await APIService.ForceStopInterface(id, nr);
        },
        async restartInterface(state, {id, nr}) {
            await APIService.RestartInterface(id, nr);

        },
        saveInterface(state, inter: IInterface) {
            APIService.SaveInterface(inter);
        },
        saveSetting(state, setting: ISetting) {
            APIService.SaveSetting(setting);
        },
        enableService(state, service: string) {
            APIService.EnableService(service);
        },
        disableService(state, service: string) {
            APIService.DisableService(service);
        },
        startService(state, service: string) {
            APIService.StartService(service);
        },
        stopService(state, service: string) {
            APIService.StopService(service);
        },
        reboot(state) {
            APIService.Reboot();
        },
        updateInterfaces(state, value) {
            this.commit('mutateInterfaces', value);
        },
        updateAllowBlockLists(state, value) {
            this.commit('mutateAllowBlockLists', value);
        },
        updateAccessControl(state, value) {
            this.commit('mutateAccessControl', value);
        },
        updateStatisticsSummary(state, value) {
            this.commit('mutateStatisticsSummary', value);
        },
        saveAllowBlockList(state, value: IAllowBlockList) {
            APIService.SaveAllowBlockList(value);
        },
        addAllowBlockList(state, value: IAllowBlockList) {
            APIService.AddAllowBlockList(value);
        },
        deleteAllowBlockList(state, value: IAllowBlockList) {
            APIService.DeleteAllowBlockList(value);
        },
        saveAccessControl(state, value: IAccessControl) {
            APIService.SaveAccessControl(value);
        },
        addAccessControl(state, value: IAccessControl) {
            APIService.AddAccessControl(value);
        },
        deleteAccessControl(state, value: IAccessControl) {
            APIService.DeleteAccessControl(value);
        },
        updateLicences(state) {
            this.commit('mutateLicences');
        },
        updatePrices(state) {
            this.commit('mutatePrices');
        },
        updateStatus(state) {
            this.commit('mutateStatus');
        },
        resetStatus(state) {
            this.commit('mutateResetInterfaces');
            this.commit('mutateInterfaces');
        },
        updateRecordings(state) {
            this.commit('mutateRecordings');
        },
        updateServices(state) {
            this.commit('mutateServices');
        },
        updateSettings(state) {
            this.commit('mutateSettings');
        },
        updateBoroSettings(state) {
            this.commit('mutateBoroSettings');
        },
        saveBoroSettings(state, settings: IBoroSettings) {
            APIService.SaveBoroSettings(settings);
        },
        updateVersions(state) {
            this.commit('mutateVersions');
        },
        updateServerStatus(state) {
            this.commit('mutateServerStatus');
        },
        updateNetworkConfig(state) {
            this.commit('mutateNetworkConfig');
        },
        updateCinegyRouteSources(state) {
            this.commit('mutateCinegyRouteSources');
        },
        updateCinegyRouteDestinations(state) {
            this.commit('mutateCinegyRouteDestinations');
        },
        updateTags(state) {
            this.commit('mutateTags');
        },
        updatePlaylists(state) {
            this.commit('mutatePlaylists');
        },
        addTag(state, tag: ITag) {
            APIService.AddTag(tag);
        },
        updateTag(state, tag: ITag) {
            APIService.UpdateTag(tag);
        },
        deleteTag(state, tag: ITag) {
            APIService.RemoveTag(tag);
        },
        updateEvents(state) {
            this.commit('mutateEvents');
        },
        async addPlaylist(state, playlist: IPlaylist): Promise<boolean> {
            return APIService.AddPlaylist(playlist);
        },
        async updatePlaylist(state, playlist: IPlaylist): Promise<boolean> {
            return APIService.UpdatePlaylist(playlist);
        },
        deletePlaylist(state, playlist: IPlaylist): Promise<boolean> {
            return APIService.RemovePlaylist(playlist);
        },
        changeNetworkConfig(state, networkConfig: INetwork) {
            this.commit('mutateNetworkConfig2', networkConfig);
        },
    },
    modules,
});
